var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
export class FastenEndpointDto {
}
__decorate([
    IsOptional(),
    IsString()
], FastenEndpointDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenEndpointDto.prototype, "platform_type", void 0);
export class FastenPortalDto {
}
__decorate([
    IsOptional(),
    IsString()
], FastenPortalDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenPortalDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenPortalDto.prototype, "portal_website", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenEndpointDto)
], FastenPortalDto.prototype, "endpoints", void 0);
export class FastenIdentifiersDto {
}
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenIdentifiersDto.prototype, "npi", void 0);
export class FastenBrandSourceDto {
}
__decorate([
    IsOptional(),
    IsString()
], FastenBrandSourceDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenIdentifiersDto)
], FastenBrandSourceDto.prototype, "identifiers", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenBrandSourceDto.prototype, "last_updated", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenBrandSourceDto.prototype, "brand_website", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenBrandSourceDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenBrandSourceDto.prototype, "sort_name", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenBrandSourceDto.prototype, "aliases", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenBrandSourceDto.prototype, "brand_ids", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenPortalDto)
], FastenBrandSourceDto.prototype, "portals", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], FastenBrandSourceDto.prototype, "hidden", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenBrandSourceDto.prototype, "platform_type", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenBrandSourceDto.prototype, "approved_apps", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenBrandSourceDto.prototype, "locations", void 0);
export class FastenSearchHighlightDto {
}
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenSearchHighlightDto.prototype, "aliases", void 0);
export class FastenSearchHitDto {
}
__decorate([
    IsOptional(),
    IsString()
], FastenSearchHitDto.prototype, "_index", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchHitDto.prototype, "_type", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchHitDto.prototype, "_id", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenSearchHitDto.prototype, "_score", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenBrandSourceDto)
], FastenSearchHitDto.prototype, "_source", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenSearchHighlightDto)
], FastenSearchHitDto.prototype, "highlight", void 0);
__decorate([
    IsOptional(),
    IsArray()
], FastenSearchHitDto.prototype, "sort", void 0);
export class FastenHitsTotalDto {
}
__decorate([
    IsOptional(),
    IsNumber()
], FastenHitsTotalDto.prototype, "value", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenHitsTotalDto.prototype, "relation", void 0);
export class FastenHitsContainerDto {
}
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenHitsTotalDto)
], FastenHitsContainerDto.prototype, "total", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenHitsContainerDto.prototype, "max_score", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenSearchHitDto)
], FastenHitsContainerDto.prototype, "hits", void 0);
export class FastenShardsDto {
}
__decorate([
    IsOptional(),
    IsNumber()
], FastenShardsDto.prototype, "total", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenShardsDto.prototype, "successful", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenShardsDto.prototype, "skipped", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenShardsDto.prototype, "failed", void 0);
export class FastenAggregationBucketDto {
}
__decorate([
    IsOptional(),
    IsString()
], FastenAggregationBucketDto.prototype, "key", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenAggregationBucketDto.prototype, "doc_count", void 0);
export class FastenAggregationDto {
}
__decorate([
    IsOptional(),
    IsNumber()
], FastenAggregationDto.prototype, "doc_count_error_upper_bound", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenAggregationDto.prototype, "sum_other_doc_count", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenAggregationBucketDto)
], FastenAggregationDto.prototype, "buckets", void 0);
export class FastenAggregationsDto {
}
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationDto)
], FastenAggregationsDto.prototype, "by_platform_type", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationDto)
], FastenAggregationsDto.prototype, "by_category", void 0);
export class FastenSearchDataDto {
}
__decorate([
    IsOptional(),
    IsNumber()
], FastenSearchDataDto.prototype, "took", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], FastenSearchDataDto.prototype, "timed_out", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenShardsDto)
], FastenSearchDataDto.prototype, "_shards", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenHitsContainerDto)
], FastenSearchDataDto.prototype, "hits", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationsDto)
], FastenSearchDataDto.prototype, "aggregations", void 0);
export class FastenSearchResponseDto {
}
__decorate([
    IsOptional(),
    IsBoolean()
], FastenSearchResponseDto.prototype, "success", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenSearchDataDto)
], FastenSearchResponseDto.prototype, "data", void 0);
export class FastenSearchResult {
}
__decorate([
    IsOptional(),
    IsString()
], FastenSearchResult.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchResult.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchResult.prototype, "sortName", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenSearchResult.prototype, "brandIds", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenPortalDto)
], FastenSearchResult.prototype, "portals", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchResult.prototype, "logoUrl", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenSearchResult.prototype, "locations", void 0);
__decorate([
    IsOptional(),
    IsNumber()
], FastenSearchResult.prototype, "score", void 0);
export function transformToSearchResults(response, environment) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const hits = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.hits) === null || _b === void 0 ? void 0 : _b.hits;
    const totalHits = (_f = (_e = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.hits) === null || _d === void 0 ? void 0 : _d.total) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : 0;
    if (!response.success || !hits || hits.length === 0) {
        console.warn("Failed to transform fasten search results despite a successful response", response);
        return { results: [], nextCursor: null, totalHits };
    }
    const results = hits.map((hit) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            id: (_a = hit._source) === null || _a === void 0 ? void 0 : _a.id,
            name: (_b = hit._source) === null || _b === void 0 ? void 0 : _b.name,
            sortName: (_c = hit._source) === null || _c === void 0 ? void 0 : _c.sort_name,
            portals: (_d = hit._source) === null || _d === void 0 ? void 0 : _d.portals,
            brandIds: (_e = hit._source) === null || _e === void 0 ? void 0 : _e.brand_ids,
            logoUrl: ((_g = (_f = hit._source) === null || _f === void 0 ? void 0 : _f.brand_ids) === null || _g === void 0 ? void 0 : _g[0]) ? `${environment.FASTEN_LOGO_BASE_URL}/${hit._source.brand_ids[0]}.png` : null,
            locations: (_h = hit._source) === null || _h === void 0 ? void 0 : _h.locations,
            score: (_j = hit._score) !== null && _j !== void 0 ? _j : null,
        });
    });
    const lastHit = hits[hits.length - 1];
    const nextCursor = (_h = (_g = lastHit === null || lastHit === void 0 ? void 0 : lastHit.sort) === null || _g === void 0 ? void 0 : _g.map((value) => String(value))) !== null && _h !== void 0 ? _h : null;
    return { results, nextCursor, totalHits };
}
